<script>
import ImageLoader from '@components/ImageLoader'

export default {
  name: 'CardCurso',
  components: {
    ImageLoader
  },
  props: {
    img: {
      type: String, default: ''
    },
    scale: {
      type: Number, default: 1
    },
    height: {
      type: String, default: 'calc(247px * var(--scale))'
    },
    width: {
      type: String, default: 'calc(210px * var(--scale))'
    }
  },
  computed: {
    styles () {
      return {
        cardCurso: {
          '--scale': this.scale,
          '--height': this.height,
          '--width': this.width
        }
      }
    }
  }
}
</script>

<template>
  <div
    class="card-curso"
    :style="styles.cardCurso"
  >
    <ImageLoader
      :url="img"
      class="img"
      @click="$emit('click')"
    />
  </div>
</template>

<style lang="scss" scoped>
.card-curso {
  cursor: pointer;
  width: var(--width);
  height: var(--height);
  border-radius: calc(6px * var(--scale));
  overflow: hidden;
  background-color: var(--surface);
  .img {
    height: 100%;
    width: 100%;
  }
}
</style>
